// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header>
</customer-profile-header>
<div class="box">
  <sub-header header="'Available account groups for: ' + \$ctrl.accountType.productDefinition.productName">
    <button
      type="button"
      command-access="CreateAccountGroup"
      class="btn btn-primary"
      ng-click="\$ctrl.createNewGroup()">
      Create new
    </button>
  </sub-header>

  <div>

    <div class="filters">
        <span class="labelled-field">
          <label>Group Name</label>
          <input type="text" class="filter-value" ng-model="\$ctrl.searchName">
        </span>
      <button type="button"
              class="btn btn-primary"
              ng-click="\$ctrl.onSearch()">
        Search Group
      </button>
    </div>

    <div>
      <table class="table table--last-column-to-right" ng-table="\$ctrl.tableConfig">
        <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Product</th>
          <th>Members</th>
          <th>Total Balance</th>
          <th>Interest Rate</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr ng-repeat="item in \$data">
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ \$ctrl.accountType.productDefinition.productName }}</td>
          <td>{{ item.accounts.length }}</td>
          <td class="text-right">{{ item.totalBalance | nxCurrency }}</td>
          <td>{{ item.currentInterestRate | rate }}</td>
          <td class="table__actions" colspan="2">
            <button type="button"
                    ng-if="\$ctrl.assignmentMode"
                    command-access="AddAccountGroupMember"
                    class="btn btn-success"
                    ng-click="\$ctrl.addAccountToGroup(item)">
              Assign
            </button>
            <button type="button"
                    ng-if="\$ctrl.assignmentMode"
                    command-access="UpdateAccountGroup"
                    class="btn btn-primary"
                    ng-click="\$ctrl.updateGroup(item.id)">
              Edit
            </button>
            <button type="button"
                    ng-if="!\$ctrl.account.groupId"
                    command-access="DeleteAccountGroup"
                    class="btn btn-danger"
                    ng-click="\$ctrl.deleteGroup(item.id)">
              Delete
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="summary-actions">
        <button type="button"
                ng-if="\$ctrl.assignmentMode"
                class="btn btn-warning"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
      </div>
    </div>
  </div>

</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/account-group/account-group-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;